module.exports = __webpack_public_path__ + "img/firebase-logo.ada7c3a3.png";